angular.module('rental')
    .directive('rentalResourceSelect', function (RentalResource) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                required: "=",
                customList: "=",
                onChange: "&"
            },
            templateUrl: "app/rental/resource/rental-resource-select.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                // scope.selected = ngModelCtrl.$viewModel || undefined;
                scope.items = scope.customList || [];
                scope.executeOnChange = scope.onChange || angular.noop;

                function refresh(result) {
                    scope.refreshing = true;
                    scope.refreshData().then(() => {
                        scope.refreshing = false;
                        scope.selected = {
                            id: result.id,
                            symbol: result.symbol,
                            fullName: result.fullName,
                            fullAddress: result.fullAddress,
                            nip: result.nip
                        };
                        scope.onSelectionChanged(scope.selected);
                    });
                }

                scope.refreshData = q => RentalResource.autocomplete({q: q}).$promise.then(items => scope.items = items);

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue;
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item);
                    }
                }
            }
        };
    });
